var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1115 -216)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1117.976 223.258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.431,1.185a8,8,0,0,0,.548,15.29,8.554,8.554,0,0,0,4.094.044,7.052,7.052,0,0,0,5.3-5.023,9.4,9.4,0,0,0,.2-4.247h-7.53v3.123h4.361a3.759,3.759,0,0,1-1.6,2.469,4.575,4.575,0,0,1-1.762.7,5.225,5.225,0,0,1-1.91,0,4.7,4.7,0,0,1-1.777-.775A4.97,4.97,0,0,1,5.522,10.3a4.844,4.844,0,0,1,0-3.115A4.964,4.964,0,0,1,6.684,5.3a4.7,4.7,0,0,1,4.738-1.237,8.07,8.07,0,0,1,1.726,1.012s.983-.979,1.473-1.471c.253-.264.529-.516.778-.787a7.745,7.745,0,0,0-2.576-1.588,8.1,8.1,0,0,0-5.391-.048",
    transform: "translate(-0.025 -0.004)",
    fill: "#6b8799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H4A1,1,0,0,1,5,0,1,1,0,0,1,4,1Z",
    transform: "translate(1135.716 224)",
    fill: "#6b8799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5A1,1,0,0,1-1,4V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V4A1,1,0,0,1,0,5Z",
    transform: "translate(1139.716 224)",
    fill: "#6b8799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414l4-4a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-4,4A1,1,0,0,1,0,5Z",
    transform: "translate(1135.716 224)",
    fill: "#6b8799"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1115 216)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLink);
export default __webpack_public_path__ + "static/media/GoogleLink.a395e4ec93075904c1094df85cba483a.svg";
export { ForwardRef as ReactComponent };